import React from 'react';

import Dialog from '../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../reusables/Dialog/extras/caption';
import iconCancel from '../../../../../../../assets/illustrations/cancel-procedure.svg';

interface IProps {
  handlerCancelProcedure: () => void;
  handlerClose: () => void;
  messageInfo?: string;
  show: boolean;
}

const CancelProcedure = ({
  handlerCancelProcedure,
  handlerClose,
  messageInfo,
  show
}: IProps) => (
  <Dialog
    handlerClose={() => handlerClose()}
    maxWidth="360px"
    show={show}
    zIndex={1000}
    textButtonA="Sí, anular"
    handlerButtonA={() => handlerCancelProcedure()}
    textButtonB="Cancelar"
    handlerButtonB={() => handlerClose()}
    img={iconCancel}
  >
    <DialogExtraCaption
      messageInfo={
        messageInfo && typeof messageInfo === 'string' ? messageInfo : undefined
      }
      subtitle="Al aceptar esta acción, recuerda que tendrás que volver a solicitarlo."
      title="¿Deseas anular este trámite?"
    />
  </Dialog>
);

export default CancelProcedure;
